import { f as r } from "./function-bind-context.js";
import { i as t } from "./indexed-object.js";
import { t as o } from "./to-object.js";
import { l as a } from "./length-of-array-like.js";
var n = function n(_n) {
    var i = 1 == _n;
    return function (e, s, f) {
      for (var c, m = o(e), d = t(m), u = r(s, f), j = a(d); j-- > 0;) if (u(c = d[j], j, m)) switch (_n) {
        case 0:
          return c;
        case 1:
          return j;
      }
      return i ? -1 : void 0;
    };
  },
  i = {
    findLast: n(0),
    findLastIndex: n(1)
  };
export { i as a };